// extracted by mini-css-extract-plugin
module.exports = {"option":"Setting_style_option__2cGjd","title":"Setting_style_title__tGF3X","quit":"Setting_style_quit__WFt5u"};